import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter.options.list('type', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter
      .options.store('post_id', 'Lander', 'posts', POST_CONFIG)
      .multi(true),
    filter.boolean('conversion_pixel', 'Conversion Pixel'),
    filter.boolean('active', 'Active'),
  ], [])
}

const TYPE_OPTIONS = [
  { label: 'Static', value: 'static' },
  { label: 'Dynamic', value: 'dynamic' },
]

const POST_CONFIG = {
  params: { content_type: 'page,post,deal,sweep' },
  parserOptions: { labelKey: "title" },
}
